import axios from 'axios';
import { getCMSAPIUrl, getAPIUrl } from '../utils/urlFactory';
import { gql } from '@apollo/client';
import { store } from '../index';

const IDENTIFIER = process.env.IDENTIFIER;
const PASSWORD = process.env.PASSWORD;

const instance = axios.create({
    baseURL: getCMSAPIUrl(),
    timeout: 600000,
    headers: {
        'Content-Type': 'application/json',
    },
});

instance.interceptors.request.use(
    (request) => {
        return request;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const signInWithPassword = async ({ mobileNumber, password }) => {
    const res = await instance.post(`/auth/local`, {
        identifier: mobileNumber,
        password: password,
    });
    return res.data;
};

export const signInWithOTP = async ({ mobileNumber, refCode, otp }) => {
    const res = await instance.post(`/auth/local`, {
        identifier: mobileNumber,
        refCode: refCode,
        otp: otp,
    });
    return res.data;
};

export const requestOTP = async (mobileNumber) => {
    const res = await instance.post(`/otp/request`, {
        mobileNumber: mobileNumber,
    });
    return res.data;
};

export const verifyOTP = async ({ OTPNumber, refCode, users_id }) => {
    const res = await instance.post(`/otp/vetify`, {
        OTPNumber: OTPNumber,
        refCode: refCode,
        users_id: users_id,
    });
    return res.data;
};

export const forgotPassword = async ({ OTPNumber, refCode, users_id, password }) => {
    const res = await instance.post(`/forgotpassword`, {
        OTPNumber: OTPNumber,
        refCode: refCode,
        users_id: users_id,
        password: password,
    });
    return res.data;
};

export const resetPassword = async ({ oldPassword, newPassword, user_id, notificationOwner }) => {
    const res = await instance.post(
        `/resetnewpassword`,
        {
            oldPassword: oldPassword,
            newPassword: newPassword,
            user_id: user_id,
            notificationOwner: notificationOwner,
        },
        {
            headers: {
                authorization: `Bearer ${store.getState().strapiToken}`,
            },
        }
    );
    return res.data;
};

export const getToken = async () => {
    const res = await instance.post(`/auth/local`, {
        identifier: IDENTIFIER,
        password: PASSWORD,
    });

    return res.data;
};

export const tokenDecrypt = async (data) => {
    const res = await instance.post(`/token/decrypt`, data);

    return res.data;
};

export const reCaptchaSiteVerify = async (data) => {
    const res = await instance.post(`/auth/recaptcha-siteverify`, data);

    return res.data;
};

export const deleteMedia = async (id) => {
    const res = await instance.delete(`/upload/files/${id}`, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res.data;
};

export const uploadMedia = async (formData) => {
    const res = await instance.post(`/upload`, formData, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
            'Content-Type': 'multipart/form-data',
        },
    });
    return res.data;
};

export const completeRegister = async (user_id, password) => {
    const res = await instance.post(`/confirm`, {
        user_id: user_id,
        password: password,
    });
    return res;
};

export const checkConfirm = async (user_id) => {
    const res = await instance.get(`/checkConfirm/${user_id}`);
    return res;
};

export const createRoom = async () => {
    const res = await axios.post(
        `${getAPIUrl()}/api/rooms`,
        { password: 'CDAEEC8F0263E74FB190A8EEEF7DB546D6E16D9325FFABA3AE0837B510738276' },
        {
            headers: {
                Authorization: `Basic Q0xJRU5UOkFJU19DT01QQU5Z`,
            },
        }
    );

    return res.data;
};

export const joinRoom = async (roomId, params) => {
    const res = await axios.post(`${getAPIUrl()}/api/rooms/${roomId}/join`, params, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });

    return res.data;
};

export const transcribe = async (roomId) => {
    const res = await axios.get(`${getAPIUrl()}/api/transcribe/contents/${roomId}`);

    return res.data;
};

export const deleteAllNotification = async (ownerId) => {
    const res = await instance.delete(`/notifications/deleteall/${ownerId}`, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const deleteNotification = async (id) => {
    const res = await instance.delete(`/notifications/${id}`, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const endSession = async (id) => {
    const res = await instance.put(`/session/end/${id}`, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const readMessage = async (id) => {
    const res = await instance.post(
        `/messages/read`,
        { id },
        {
            headers: {
                authorization: `Bearer ${store.getState().strapiToken}`,
            },
        }
    );

    return res;
};

export const imageMessage = async (form) => {
    const res = await instance.post(`/messages/image`, form, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
            'Content-Type': 'multipart/form-data',
        },
    });

    return res;
};

export const bookSession = async (data) => {
    const res = await instance.post(`/books/session`, data);

    return res;
};

export const mindgymReport = async (staffId, sessionId) => {
    const res = await instance.get(`/mindgym/report/${staffId}/${sessionId}`, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};
export const mindgymDownloadReport = async (staffId, sessionId) => {
    const res = await instance({
        url: `/mindgym/download/${staffId}/${sessionId}`,
        method: 'GET',
        responseType: 'blob',
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const GET_USER = gql`
    query GET_USER($id: ID!) {
        user(id: $id) {
            id
            fullname
            avatar {
                id
                url
            }
            staff {
                id
                deactivated
                staff_role {
                    name
                }
                hospital {
                    id
                    name
                    avatar {
                        url
                    }
                }
            }
            patients {
                id
                hospital {
                    id
                    name
                    avatar {
                        url
                    }
                }
            }
        }
    }
`;

export const GET_MESSAGES = gql`
    query GET_MESSAGES($myId: String!, $targetId: String!) {
        meSend: messages(where: { sender: $myId, receiver: $targetId, isGroup: false }) {
            id
            createdAt
            sender
            receiver
            text
            image {
                url
            }
            isGroup
            patient {
                id
            }
            staff {
                id
            }
        }
        meReceived: messages(where: { sender: $targetId, receiver: $myId, isGroup: false }) {
            id
            createdAt
            sender
            receiver
            text
            image {
                url
            }
            isGroup
            patient {
                id
            }
            staff {
                id
            }
        }
    }
`;

export const GET_GROUP_MESSAGES = gql`
    query GET_GROUP_MESSAGES($meetId: String!) {
        messages(where: { receiver: $meetId, isGroup: true }) {
            id
            createdAt
            sender
            receiver
            text
            isGroup
            patient {
                id
                user {
                    fullname
                }
            }
            staff {
                id
                user {
                    fullname
                }
            }
        }
    }
`;

export const GET_OPEN_MESSAGES = gql`
    query GET_OPEN_MESSAGES($id: ID!) {
        session(id: $id) {
            messages(limit: -1, sort: "createdAt:desc") {
                createdAt
                id
                sender
                senderRole
                text
                staff {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                    }
                }
                patient {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                    }
                }

                session {
                    id
                }
            }
        }
    }
`;

export const GET_MEET_INFO = gql`
    query GET_MEET_INFO($id: ID!) {
        meet(id: $id) {
            id
            name
        }
    }
`;

export const GET_PATIENT = gql`
    query GET_PATIENT($id: ID!) {
        patient(id: $id) {
            id
            user {
                fullname
                avatar {
                    url
                }
            }
        }
    }
`;

export const GET_PROVIDER = gql`
    query GET_PROVIDER($id: ID!) {
        staff(id: $id) {
            id
            user {
                fullname
                avatar {
                    url
                }
            }
            deactivated
        }
    }
`;

export const GET_UNREAD_NOTIFICATIONS_COUNT = gql`
    query GET_UNREAD_NOTIFICATIONS_COUNT($id: ID!) {
        notificationsConnection(where: { isRead: false, owner: $id }) {
            aggregate {
                count
            }
        }
    }
`;

export const GET_NOTIFICATION = gql`
    query GET_NOTIFICATION($id: ID!) {
        notifications(sort: "createdAt:desc", where: { owner: $id }) {
            id
            createdAt
            type
            isRead
            owner
            meet {
                id
                type
                name
                startDate
                startTime
                endTime
            }
            session {
                id
                date
                startTime
                endTime
                meet {
                    id
                    name
                    type
                    staff {
                        user {
                            fullname
                            avatar {
                                url
                            }
                        }
                    }
                }
            }
            staff {
                id
                user {
                    fullname
                    avatar {
                        url
                    }
                }
            }
            patient {
                id
                user {
                    fullname
                    avatar {
                        url
                    }
                }
            }
        }
    }
`;

export const UPDATE_NOTIFICATION_ISREAD = gql`
    mutation UPDATE_NOTIFICATION_ISREAD($id: ID!) {
        updateNotification(input: { where: { id: $id }, data: { isRead: true } }) {
            notification {
                id
                owner
                isRead
            }
        }
    }
`;

export default instance;
